import { render, staticRenderFns } from "./MaterialSettlement.vue?vue&type=template&id=320539f8"
import script from "./MaterialSettlement.vue?vue&type=script&lang=js"
export * from "./MaterialSettlement.vue?vue&type=script&lang=js"
import style0 from "./MaterialSettlement.vue?vue&type=style&index=0&id=320539f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports